import React, { useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";


const barColors = {
  counterFeit: "#9A64B2",
  crossSelling: "#FFA500",
};

const BarChart = ({ type, crossSellingData }) => {
  const dataArray = Array.isArray(crossSellingData) ? crossSellingData : [];

  const categories = dataArray.map((item) => item.location);
  const showScroll = categories.length > 5;
  const [pointWidth, setPointWidth] = useState(50);
  
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth > 1280) {
        setPointWidth(50);
      } else if (screenWidth >= 900 && screenWidth <= 1280) {
        setPointWidth(20);
      } else {
        setPointWidth(50);
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = {
    chart: {
      type: "column",
      height: 200,
      spacingTop: 10,
      marginTop: 30,
      backgroundColor: "transparent",
      zoomType:"x"
  
    },
    title: { text: "" },
    xAxis: {
      categories,
      scrollbar: {
        enabled: showScroll,
      },
      ...(showScroll ? { min: 0, max: 4 } : {}),
      labels: {
        rotation: 0, // Change to 0 for better centering
        align: "center", // Ensures label is centered under the bar
        x: 0,
        y: 20, // Adjust if needed to control vertical position
        style: {
          fontSize: "12px",
          fontWeight: "500",
        },
      },
      lineColor: barColors[type],
      tickLength: 0,
    },
    
    yAxis: {
      visible: false,
    },
    tooltip: {
      formatter: function () {
        return `${this.key} : <b>${this.y}</b>`;
      },
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 5,
        color: barColors[type],
        pointPadding: 0.1,
        groupPadding: 0.1,
      },
      series: {
        pointWidth: pointWidth,
      },
    },
    series: [
      {
        data: dataArray.map((item) =>
          type === "crossSelling"
            ? item.cross_selling_count
            : item.counterfeit_count
        ),
      },
    ],
  };
  

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default BarChart;
